import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavBarVisibilityService {

  public hideOnSideNav: boolean;

  constructor() {
    this.hideOnSideNav = false;
  }
}
